import moment from "moment";

export const getTableConfig = (tab, year) => {
    return tab === "mtd" ? configMonthToDate : tab === "l3y" ? configLast3Years(year) : [];
};

const configMonthToDate = [
    {name: 'january', label: "JAN", options: {sort: false}},
    {name: 'february', label: "FEB", options: {sort: false}},
    {name: 'march', label: "MAR", options: {sort: false}},
    {name: 'april', label: "APR", options: {sort: false}},
    {name: 'march', label: "MAY", options: {sort: false}},
    {name: 'june', label: "JUN", options: {sort: false}},
    {name: 'july', label: "JUL", options: {sort: false}},
    {name: 'august', label: "AUG", options: {sort: false}},
    {name: 'september', label: "SEP", options: {sort: false}},
    {name: 'october', label: "OCT", options: {sort: false}},
    {name: 'november', label: "NOV", options: {sort: false}},
    {name: 'december', label: "DEC", options: {sort: false}},
];

const configLast3Years = (val) => {
    const year = val ? Number(val) : Number(moment().format("YYYY"))
    return [
        {name: "year2Quartal1", label: `Q1 ${year - 2}`, options: {sort: false}},
        {name: "year2Quartal2", label: `Q2 ${year - 2}`, options: {sort: false}},
        {name: "year2Quartal3", label: `Q3 ${year - 2}`, options: {sort: false}},
        {name: "year2Quartal4", label: `Q4 ${year - 2}`, options: {sort: false}},
        {name: "year1Quartal1", label: `Q1 ${year - 1}`, options: {sort: false}},
        {name: "year1Quartal2", label: `Q2 ${year - 1}`, options: {sort: false}},
        {name: "year1Quartal3", label: `Q3 ${year - 1}`, options: {sort: false}},
        {name: "year1Quartal4", label: `Q4 ${year - 1}`, options: {sort: false}},
        {name: "yearQuartal1", label: `Q1 ${year}`, options: {sort: false}},
        {name: "yearQuartal2", label: `Q2 ${year}`, options: {sort: false}},
        {name: "yearQuartal3", label: `Q3 ${year}`, options: {sort: false}},
        {name: "yearQuartal4", label: `Q4 ${year}`, options: {sort: false}},
    ]
};

export const configFincoyGrowth = [
    {name: "namaCabang", label: "Nama Cabang", options: {sort: false}},
    {name: "lastMonth", label: "Last Month", options: {sort: false}},
    {name: "thisMonth", label: "This Month", options: {sort: false}},
    {name: "growth", label: "Growth", options: {sort: false,customBodyRender: (val) => (val!== null ? `${val}%` : null)}},
];

export const configFincoyContribution = (val) => {
    const year = val ? Number(val) : Number(moment().format("YYYY"))
    return [
        {name: "leasingName", label: "\n", options: {sort: false}},
        {name: "last2Year", label: year - 2, options: {sort: false}},
        {name: "last1Year", label: year - 1, options: {sort: false}},
        {name: "lastYear", label: year, options: {sort: false}},
    ]
};